import { ActionIcon, useComputedColorScheme, useMantineColorScheme } from '@mantine/core'

/** Light/dark toggle — the sidebar's ☀️/🌙 button from `sidebar_qt.py`. */
export function ThemeToggle() {
  const { setColorScheme } = useMantineColorScheme()
  // `useComputedColorScheme` resolves "auto" to what is actually on screen, so
  // the icon shows the scheme you'd switch TO rather than the literal setting.
  const scheme = useComputedColorScheme('light')

  return (
    <ActionIcon
      variant="default"
      // Matches the account button beside it exactly. Mantine has no
      // preset that equals an `xs` Button (30px), and a 34px icon next
      // to a 30px button reads as a mistake.
      size={30}
      aria-label="עבור למצב כהה / בהיר"
      title="עבור למצב כהה / בהיר"
      onClick={() => setColorScheme(scheme === 'dark' ? 'light' : 'dark')}
    >
      {scheme === 'dark' ? '☀️' : '🌙'}
    </ActionIcon>
  )
}
